import { useState, useEffect } from "react";

export const useVitalsData = () => {
  const [vitals, setVitals] = useState({
    heartRate: 72,
    spO2: 98,
    temperature: 98.6,
    bloodPressure: { systolic: 120, diastolic: 80 },
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setVitals({
        heartRate: Math.floor(Math.random() * 20) + 65, // 65-85
        spO2: Math.floor(Math.random() * 5) + 95, // 95-100
        temperature: Number((Math.random() * 2 + 97.5).toFixed(1)), // 97.5-99.5
        bloodPressure: {
          systolic: Math.floor(Math.random() * 20) + 110, // 110-130
          diastolic: Math.floor(Math.random() * 15) + 70, // 70-85
        },
      });
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return vitals;
};
